<template>
  <div>
    <v-card>
      <v-card-title>
        <h1>{{ title }}</h1>

        <v-spacer></v-spacer>

        <v-text-field
          class="search-bar"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          dense
        ></v-text-field>

        <v-dialog v-model="dialog" max-width="750px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Add {{ itemTitle }}</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <h1>{{ formTitle }}</h1>
            </v-card-title>

            <v-card-text>
              <v-form ref="form" v-model="valid">
                <slot></slot>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
              <v-btn color="primary" @click="saveItem">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :search="search"
        :loading="loading"
      >
        <template v-slot:item.enabled="{ item }">
          <span>{{ item.enabled ? 'Yes' : 'No' }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu offset-y min-width="120">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item v-if="routeName" @click="viewItem(item)">
                <v-list-item-icon>
                  <v-icon dense>mdi-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>View</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="editItem(item)">
                <v-list-item-icon>
                  <v-icon dense>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="deleteItem(item)">
                <v-list-item-icon>
                  <v-icon dense>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <snackbar-message
      :snackbar="snackbar"
      :snackbar-text="snackbarText"
      @close="snackbar = false"
    ></snackbar-message>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import SnackbarMessage from '@/components/SnackbarMessage.vue'

export default {
  name: 'BaseTable',
  components: {
    SnackbarMessage
  },
  props: {
    title: String,
    itemTitle: {
      type: String,
      default: 'Item'
    },
    routeName: String,
    getUrl: String,
    headers: Array,
    url: String,
    item: Object,
    itemId: String,
    getId: String
  },
  data() {
    return {
      dialog: false,
      editedIndex: -1,
      search: '',
      items: [],
      loading: false,
      valid: true,
      snackbar: false,
      snackbarText: ''
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? 'New ' + this.itemTitle
        : 'Edit ' + this.itemTitle
    },
    fullUrl() {
      return this.getUrl ? this.url + this.getUrl : this.url
    }
  },
  created() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      ApiService.get(this.fullUrl, this.getId)
        .then(response => {
          this.items = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          ApiService.put(this.url, this.itemId, this.item).then(() => {
            this.snackbarText = this.itemTitle + ' updated successfully'
            this.snackbar = true
            this.getItems()
          })
        } else {
          ApiService.post(this.url, this.item).then(() => {
            this.snackbarText = this.itemTitle + ' created successfully'
            this.snackbar = true
            this.getItems()
          })
        }
      }

      if (this.valid) this.dialog = false
    },
    editItem(item) {
      this.$emit('set-item', item)
      this.editedIndex = this.items.indexOf(item)
      this.dialog = true
    },
    deleteItem(item) {
      this.$emit('set-item', item)

      this.$nextTick(() => {
        if (confirm('Are you sure you want to delete this item?')) {
          ApiService.delete(this.url, this.itemId).then(() => {
            this.snackbarText = this.itemTitle + ' deleted successfully'
            this.snackbar = true
            this.getItems()
          })
        }

        this.$refs.form.reset()
      })
    },
    viewItem(item) {
      this.$emit('set-item', item)

      this.$nextTick(() => {
        this.$router.push({
          name: this.routeName,
          params: { id: this.itemId }
        })
      })
    }
  },
  watch: {
    dialog: function() {
      if (!this.dialog) {
        setTimeout(() => {
          this.$refs.form.reset()
          this.editedIndex = -1
        }, 300)
      }
    }
  }
}
</script>

<style scoped>
.search-bar {
  max-width: 300px;
  margin-top: 0px;
  margin-right: 20px;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px;
}
</style>
